module.exports = __webpack_public_path__ + "static/eyeball-reporter-logo-26052435c7e6451678949a232a67c3c0.svg";